import { cn } from '@/lib/cn';
import { hap } from '@/lib/haptics';
interface Props<T extends string> { value: T; onChange: (v: T) => void; options: { id: T; label: string }[] }
export function Segmented<T extends string>({ value, onChange, options }: Props<T>) {
  return (
    <div className="inline-flex p-1 rounded-md bg-paper-rec ring-1 ring-paper-edge">
      {options.map(o => (
        <button key={o.id} onClick={() => { hap.selection(); onChange(o.id); }}
          className={cn('px-4 h-9 rounded-[10px] text-[13px] font-medium transition',
            value === o.id ? 'bg-paper-elev text-ink-1 shadow-sm' : 'text-ink-2')}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
